import { getCurrentUserRole } from "modules/utilities/utility";
import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { UploadOutlined } from "@ant-design/icons";
import { Button, Col, Row, Select, Upload } from "antd";
import isEmpty from "lodash/isEmpty";
import { useMemo } from "react";
import { useAllCommunities } from "pages/store";
import { useToast } from "modules/navbar/top/store/toasterStore";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useLocation } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";

function BulkAddOrder() {
  const [modalShow, setModalShow] = useState(false);
  const [fileData, setFileData] = useState(null);
  const [community, setCommunity] = useState("");
  const [message, setMessage] = useState("");
  const [userId] = useState(secureLocalStorage.getItem("id"));
  const [roleId] = useState(secureLocalStorage.getItem("role"));
  const { bulkLoading, postAddBulkCommunity } = useAllCommunities();
  const { communityData, fetchAllCommunities } = useAllCommunities();
  const [defaultValue, setDefaultValue] = useState();
  const { setToaster } = useToast();
  const location=useLocation();
  const searchParams = new URLSearchParams(location.search);
  const defaultKey=searchParams.get("name");

  useEffect(() => {
    fetchAllCommunities();
  }, []);

  const defaultOption = defaultKey
    ? communityData.find((option) => option?.name === defaultKey)
    : null;
  const _defaultOption = defaultOption?.name;

  useEffect(() => {
    const defaultOption = defaultKey
      ? communityData.find((option) => option?.name === defaultKey)
      : null;
    const _defaultValue = defaultOption?.id;
    setCommunity(_defaultValue);
    setDefaultValue(_defaultValue);
    console.log("defaultOption", defaultOption?.name);
  }, [defaultKey, communityData]);

  useEffect(() => {
    if (message) {
      {
        toast(message, {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        setMessage("");
      }
    }
  }, [message]);

  const communityOption = useMemo(() => {
    return communityData?.map((val) => ({
      label: val.name,
      value: val.id,
      children: val.name,
    }));
  }, [communityData]);

  const handleFileChange = (info) => {
    if (info.fileList.length > 0) {
      const file = info.fileList[0].originFileObj;
      setFileData(file);
    } else if (info.file.status === "error") {
      setMessage("File upload failed!");
    }
  };
  const resetFile = () => {
    setFileData({});
  };
  const beforeUpload = (file) => {
    const allowedFileTypes = [
      "text/csv",
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    ];
    const fileType = file.type;

    if (!allowedFileTypes.includes(fileType)) {
      setMessage("Only CSV and XLSX file formats are allowed.");
      return false;
    }
    return true;
  };

  const handleFakeRequest = ({ onSuccess }) => {
    return setTimeout(() => {
      onSuccess("ok");
    }, 0);
  };

  const upload = () => {
    if (!fileData || !community) {
      setMessage("Please select a file and community");
      return;
    }
    let file = new FormData();
    file.append("file", fileData);
    file.append("communityName", community);
    file.append("userId", userId);
    file.append("roleId", roleId);
    postAddBulkCommunity(file, setToaster, setMessage, setModalShow);
  };

  return (
    <div>
      <button
        className={
          getCurrentUserRole() === "support"
            ? "disabled btn btn-primary"
            : "btn btn-primary"
        }
        onClick={() => setModalShow(true)}
      >
        Bulk Add Members
      </button>

      <Modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            <div className="d-flex gap-5">
              <div>Bulk Add Members</div>
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row gutter={16} align="middle">
            <Col span={16}>
              <Upload
                customRequest={handleFakeRequest}
                accept=".csv,.xlsx"
                className="text-center"
                name="file"
                beforeUpload={beforeUpload}
                onChange={handleFileChange}
                maxCount={1}
                onRemove={resetFile}
              >
                <Button icon={<UploadOutlined />}>Add File</Button>
              </Upload>
            </Col>
            <Col span={8}>
              <Select
                allowClear
                showSearch
                placeholder="Community"
                defaultValue={_defaultOption}
                onChange={setCommunity}
                style={{ width: "100%" }}
                filterOption={(inputValue, option) =>
                  option.children
                    .toLowerCase()
                    .indexOf(inputValue.toLowerCase()) !== -1
                }
              >
                {communityOption.map((option) => (
                  <Select.Option key={option.value} value={option.value}>
                    {option.label}
                  </Select.Option>
                ))}
              </Select>
            </Col>
          </Row>
          <Button
            className="w-max mt-2"
            disabled={isEmpty(fileData)}
            loading={bulkLoading}
            onClick={upload}
            type="primary"
          >
            Upload
          </Button>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={() => setModalShow(false)}>Close</Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default BulkAddOrder;
